import { WorkLocationTypeCodes } from '@Enum/index';
import { AttendanceRequestFormValues } from './types';
import { AttendanceRequestCodes } from './enum/AttendanceRequestTypeCodes.enum';

export const initialValuesForm: AttendanceRequestFormValues = {
  empNumber: '',
  currentLocation: '',
  leaveTypeID: AttendanceRequestCodes.ADDITIONAL_PERMANENT_ACCESS,
  taReqToCompID: '',
  wlId: WorkLocationTypeCodes.DEPARTMENT,
  deptProjID: null,
  remarks: '',
  startDate: '',
  endDate: '',
  totDays: 0,
  // 'reason' passed as groupID for AttendaceRequest
  groupID: null,
};
